module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\">\n  <mat-icon>add</mat-icon>\n</div>\n"